const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    },
    /* {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    } */
  ]
}

const defaultForm = {
  datetimerange: [new Date().getTime() - 7 * 24 * 3600 * 1000, new Date()],
  norm: 'pm10',
  particle: 'particle',
  particleCoefficient: 1,
  showDirection: false
}

// 风向表盘
const windNameMap = {
  1: '北',
  2: '北东北',
  3: '东北',
  4: '东东北',
  5: '东',
  6: '东东南',
  7: '东南',
  8: '南东南',
  9: '南',
  10: '南西南',
  11: '西南',
  12: '西西南',
  13: '西',
  14: '西西北',
  15: '西北',
  16: '北西北'
};
// 风向角对应风向
const wind_directions = [
  {
    id: 1,
    name: '北风',
    range: [337.5, 22.5]
  },
  {
    id: 2,
    name: '东北风',
    range: [22.5, 67.5]
  },
  {
    id: 3,
    name: '东风',
    range: [67.5, 112.5]
  },
  {
    id: 4,
    name: '东南风',
    range: [112.5, 157.5]
  },
  {
    id: 5,
    name: '南风',
    range: [157.5, 202.5]
  },
  {
    id: 6,
    name: '西南风',
    range: [202.5, 247.5]
  },
  {
    id: 7,
    name: '西风',
    range: [247.5, 292.5]
  },
  {
    id: 8,
    name: '西北风',
    range: [292.5, 337.5]
  }
];

export {pickerOptions, defaultForm, windNameMap, wind_directions}



// WEBPACK FOOTER //
// ./src/components/AverageParticle/options.js